import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BUSINESS, IMAGES, CITIES } from "@/data";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden bg-[var(--ink)] text-white">
      <div className="noise-layer pointer-events-none absolute inset-0 opacity-[0.04]" />
      <div className="relative mx-auto max-w-[1400px] px-6 py-20 lg:px-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src={IMAGES.logoWhite} alt="logo" className="h-10 w-10" />
              <span className="font-display text-2xl font-extrabold tracking-tight">Magical Cleaning Team</span>
            </div>
            <p className="mt-6 max-w-md text-base leading-relaxed text-white/60">
              Affordable house cleaning, deep cleaning, move-in/move-out cleaning and office cleaning across
              Kitchener, Waterloo & Cambridge. Friendly, reliable, professional — spotless spaces, every single time.
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {CITIES.map((c) => (
                <Link
                  key={c.slug}
                  to={`/${c.slug}`}
                  data-testid={`footer-area-${c.slug}`}
                  className="border border-white/15 px-4 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-white/70 transition-colors hover:border-[var(--mint)] hover:text-white"
                >
                  Cleaning in {c.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-white/40">Explore</p>
            <ul className="mt-5 space-y-3 text-white/70">
              {[["Home", "/"], ["About Us", "/about"], ["Services", "/services"], ["Contact", "/contact"]].map(([l, to]) => (
                <li key={to}>
                  <Link to={to} className="nav-link text-base hover:text-white">{l}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="overline text-white/40">Get in touch</p>
            <ul className="mt-5 space-y-4 text-white/80">
              <li>
                <a href={`tel:${BUSINESS.phoneHref}`} data-testid="footer-phone" className="flex items-center gap-3 hover:text-white">
                  <Phone className="h-4 w-4 text-[var(--mint)]" /> {BUSINESS.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`mailto:${BUSINESS.email}`} className="flex items-center gap-3 hover:text-white">
                  <Mail className="h-4 w-4 text-[var(--mint)]" /> {BUSINESS.email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="h-4 w-4 text-[var(--mint)]" /> {BUSINESS.hours}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/40 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} Magical Cleaning Team. All rights reserved.</p>
          <p>Cleaning Services Kitchener · House Cleaning Waterloo · Move-out Cleaning Cambridge · House Cleaning Near Me</p>
        </div>
      </div>
    </footer>
  );
}
